module.exports = __webpack_public_path__ + "static/media/version-history-icon.fe1bcba0.svg";